import styled from "@emotion/styled";
import {
  EmailInput as SignUpNewsletterEmailInput,
  StyledSignupButton as SignUpNewsletterSignUpButton,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton as SignUpButtonSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import {
  Container as SocialButtonContainer,
  IconContainer as SocialButtonIconContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Description } from "./description-display/styles";

export const Container = styled.div`
  inline-size: 100%;

  color: #000000;
  text-align: start;
`;

export const FadeContainer = styled.div`
  inline-size: 100%;
`;

export const CollapsedContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 12px 16px;
  align-items: flex-start;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    flex-wrap: nowrap;
    align-items: stretch;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 4px;

  min-inline-size: 0;

  ${theme.breakpoints.up("tablet")} {
    flex: 0 1 auto;
    gap: 8px;
  }
`;

export const CTAContainer = styled.div`
  ${SignUpButtonSubmitButton} {
    display: inline-flex;
    gap: 8px;
    align-items: center;

    block-size: auto;
    min-inline-size: auto;
    padding: 0;

    color: #2c4692;
    font-weight: 700;
    font-family: ${fontRobotoCondensed};

    border: 0;

    background-color: transparent;
  }
`;

export const VerticalDivider = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;
    flex: 0 0 auto;
    align-self: stretch;

    inline-size: 1px;

    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  gap: 12px;

  min-inline-size: 0;

  ${Description} {
    padding-inline-start: 12px;

    border-inline-start: 1px solid #000000;
  }

  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 0;
    gap: 8px;

    ${Description} {
      padding-inline-start: 0;

      border-inline-start: none;
    }
  }
`;

export const ExpandedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;

  ${SignUpButtonSubmitButton} {
    flex-shrink: 0;

    block-size: 36px;
    min-inline-size: auto;
    padding-inline: 16px;

    font-weight: 700;
    font-family: ${fontRobotoCondensed};
    white-space: nowrap;
    text-transform: uppercase;

    background-color: #2c4692;
  }

  ${SignUpNewsletterSignUpButton} {
    min-inline-size: 74px;
    padding-inline: 10px;
  }

  ${SignUpNewsletterSignUpButton}${SignUpButtonSubmitButton} span {
    position: static;
  }

  ${SignUpNewsletterEmailInput} {
    block-size: 36px;

    ${theme.breakpoints.up("tablet")} {
      inline-size: 218px;
    }
  }

  ${SocialButtonContainer} {
    ${SocialButtonIconContainer} {
      block-size: 36px;

      background-color: #ffffff;
    }
  }
`;

export const AgreementContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  inline-size: 100%;
  min-inline-size: 0;
`;

export const AgreementCheckboxContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;

  cursor: pointer;
`;

export const AgreementDescription = styled.div`
  flex: 1 1 0;

  color: #333333;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 1.3;
  text-align: start;
`;

type TermAndConditionContainerProps = {
  $tone?: "gray" | "light";
};

export const TermAndConditionLink = styled.a`
  margin-block: 0;

  text-decoration: underline;
`;

export const TermAndConditionContainer = styled.p<TermAndConditionContainerProps>`
  max-inline-size: 100%;
  margin-block: 0;

  color: ${props => (props.$tone === "light" ? "#666666" : "#727272")};
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 1.1;
  text-align: start;
  word-break: break-word;

  ${TermAndConditionLink} {
    color: inherit;
  }
`;

export const AgreementRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    align-items: center;

    ${TermAndConditionContainer} {
      flex-shrink: 0;

      white-space: nowrap;
    }
  }
`;
